export default __webpack_public_path__ + "static/media/connect_device.c531bb9d.svg";